module.exports = __webpack_public_path__ + "img/viennoiseries.9e8ab379.png";